import { CommonModule, JsonPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { Subject, debounceTime } from 'rxjs';

@Component({
  selector: 'shared-otp-input',
  imports: [CommonModule, FormsModule],
  templateUrl: './otp-input.component.html',
  styleUrl: './otp-input.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtpInputComponent implements OnInit {
  protected changeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  @ViewChildren('optInput') inp!: QueryList<ElementRef>;
  @Output() allInputsFiledChange = new EventEmitter<string[]>();
  @Input() size = 6;
  result: string[] = [];
  private emitChangeSubject = new Subject<void>();

  ngOnInit(): void {
    this.result = new Array(this.size).fill(null);
    this.emitChangeSubject.pipe(takeUntilDestroyed(this.destroyRef), debounceTime(1000)).subscribe(() => this._emitChange());
  }

  onKeyUp(event: Event, index: number): void {
    const el = event.target as HTMLInputElement;
    if (!el.value) {
      const prev = this.inp.get(index - 1) || this.inp.get(0);
      prev?.nativeElement.focus();
      return;
    }

    if (el.value) {
      const value = el.value.split('');
      const last = Math.min(this.result.length, index + value.length);
      for (let curr = index; curr < last; curr++) {
        this.result[curr] = value[curr - index];
      }
      this.inp.get(last)?.nativeElement.focus();

      this.emitChangeSubject.next();
      return;
    }
  }

  onPaste(event: ClipboardEvent): void {
    const passCode = event?.clipboardData?.getData('text')?.split('') || [];
    setTimeout(() => {
      for (let index = 0; index < Math.min(this.result.length, passCode.length); index++) {
        this.result[index] = passCode[index];
      }
      this.changeDetectorRef.detectChanges();
      this.emitChangeSubject.next();
    }, 0);
  }

  private _emitChange(): void {
    if (this.result.findIndex((d) => d === null || d === undefined || d === '' || isNaN(+d)) !== -1) return;
    this.allInputsFiledChange.emit(this.result);
  }
}
